import { render, staticRenderFns } from "./TermOfUseModal.vue?vue&type=template&id=15c1ac7c"
import script from "./TermOfUseModal.vue?vue&type=script&lang=js"
export * from "./TermOfUseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports